// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2e8R2","text":"SelectPayment_text__3310Y","title":"SelectPayment_title__3AiAR","btn":"SelectPayment_btn__3c456"};